import {fetchApi} from 'shared/actions/fetchApi'
import {actionMap} from '../reducers/index'
import * as types from './types'
import handleError from 'shared/errorHandler/actions/handleError'
import resetError from 'shared/errorHandler/actions/resetError'

export default (flightId) => dispatch => {
    dispatch({type: types.GET_PRODUCT_LIST_START})
    dispatch(resetError())
    return fetchApi('/api/fb/briefing/' + flightId)
        .then(response => response.json())
        .then(response => {
            dispatch({
                type: types.GET_PRODUCT_LIST_SUCCESS, response: response
            })
        }).catch(error => {
            dispatch({
                type: types.GET_PRODUCT_LIST_FAILURE
            })
            dispatch(handleError({message: error.message, title: 'Error loading products.'}))
        })
}

export const handler_GET_PRODUCT_LIST_START = (reduxState) => {
    return ({
        ...reduxState,
        isLoading: true,
        data: undefined,
        selectedIds: undefined,
        loadingIds: undefined
    })
}

export const handler_GET_PRODUCT_LIST_SUCCESS = (reduxState, action) => {
    return ({
        ...reduxState,
        isLoading: false,
        data: action.response.Products || []
    })
}

export const handler_GET_PRODUCT_LIST_FAILURE = (reduxState, action) => {
    return ({
        ...reduxState,
        isLoading: false,
        data: undefined
    })
}

actionMap[types.GET_PRODUCT_LIST_START] = handler_GET_PRODUCT_LIST_START
actionMap[types.GET_PRODUCT_LIST_SUCCESS] = handler_GET_PRODUCT_LIST_SUCCESS
actionMap[types.GET_PRODUCT_LIST_FAILURE] = handler_GET_PRODUCT_LIST_FAILURE


// WEBPACK FOOTER //
// ./src/screens/briefing/products/actions/getProductList.js